import { RouteShareService } from 'src/app/shared/services/route-share.service';



import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
export function BlocklyCategory_STAGES(name: string = "unnamed", BH: BlocklyHelperService, rss: RouteShareService, icon?: string): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.STAGES, name: name, contents: [] };
  cat.contents = [
    BH.StackedBlockContents("STAGE", ["Erste Stage|___FIRST_STAGE___", "Letzte Stage|___LAST_STAGE___", "Vorherige Stage|___PREV_STAGE___", "Nächste Stage|___NEXT_STAGE___", ...rss._allStages()]),
    BH.castTypeBlock("STAGE"),
    BH.label("Aktionen"),
    BH.withNested(
      BH.action("STAGE_GOTO", "Gehe zu {{ stage[@check=STAGE] }}", "await RAGAI.STAGE.goTo({{stage}});", false, icon),
      [{ forValue: "stage", isShadow: true, targetBlockType: 'BLOCK_STACK_STAGE' }]
    ),
    //    BH._custom("STAGE_CURRENT", "@output:STAGE\nAktuelle Stage {{prop:dropdown=name,hidden,sortIndex,footer,title}}", "(RAGAI.STAGE.currentStage && RAGAI.STAGE.currentStage.{{prop}})", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
    BH.label("Eigenschaften & Werte"),
    BH.propertyDropdown(
      "CurrentStage_PROPERITES",
      "Aktuelle Stage",
      [
        ["🔡 Titel", "(RAGAI.STAGE.currentStage && RAGAI.STAGE.currentStage.title)"],
        ["🔡 Name (interne ID)", "(RAGAI.STAGE.currentStage && RAGAI.STAGE.currentStage.name)"],
        ["⎇ ist Sichtbar in der Stageliste", "(RAGAI.STAGE.currentStage && !RAGAI.STAGE.currentStage.hidden)"],
        ["⎇ footer Sichtbar", "(RAGAI.STAGE.currentStage && RAGAI.STAGE.currentStage.footer)"],
        ["⎇ erzwingt Skills", "(RAGAI.STAGE.currentStage && RAGAI.STAGE.currentStage.forceSkills)"],
        ["⎇ Eine Stage ist gesetzt", "(RAGAI.STAGE.currentStage != undefined)"]

      ]),


    //  NOCH NICHT
    //this.BH._custom("STAGE_ALLSTAGES", "@output:STAGE\nAlle Stages", "RAGAI.STAGE.allStages;", { colour: BLOCKLY_COLORS.EVENTS_LIGHT }),
    //this.BH._custom("STAGE_VISIBLESTAGES", "@output:STAGE\nSichtbare Stages", "RAGAI.STAGE.visibleStages;", { colour: BLOCKLY_COLORS.EVENTS_LIGHT })

  ];

  // Deprecated – nur registrieren, nicht in Toolbox anzeigen
  BH.withNested(
    BH.action("STAGE_HIDE_SHOW", "Stage {{ stage[@check=STAGE] }} {{func:dropdown=anzeigen|show,verbergen|hide}} ", "RAGAI.STAGE.{{func}}({{stage}});"),
    [{ forValue: "stage", isShadow: true, targetBlockType: 'BLOCK_STACK_STAGE' }]
  );
  BH.withNested(
    BH.action("STAGE_DELETE", "Stage: Entferne {{ stage[@check=STAGE] }}", "RAGAI.STAGE.remove({{stage}});"),
    [{ forValue: "stage", isShadow: true, targetBlockType: 'BLOCK_STACK_STAGE' }]
  );

  return cat;


}
